import { Button } from "@/components/ui/button";
import { memo, useEffect, useRef } from "react";
import { useAppSelector } from "../../../store/hooks";
import styles from "./TutorLiveScreen.module.css";

const Message = memo(
  ({ senderName, text }: { senderName: string; text: string }) => {
    return (
      <div className={styles.message}>
        <p className={styles.messageSender}>
          {Array.isArray(senderName?.split(" "))
            ? senderName.split(" ").slice(0, 2).join(" ")
            : senderName}
        </p>
        <p className={styles.messageBody}>{text}</p>
      </div>
    );
  }
);

const Chat = memo(
  ({
    sendMessage,
  }: {
    sendMessage: ({ senderId, senderName, text }) => void;
  }) => {
    const textInputRef = useRef<HTMLInputElement>(null);
    const newestMessageRef = useRef<HTMLDivElement>(null);
    const chatContainerRef = useRef<HTMLDivElement>(null);
    const { chat } = useAppSelector((state) => state.liveSession);
    const { uid, user_display_name } = useAppSelector(
      (state) => state.store.user
    );

    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && chatContainerRef.current) {
            chatContainerRef.current.scrollTo({
              top: chatContainerRef.current.scrollHeight,
              behavior: "smooth",
            });
          }
        },
        { threshold: 1.0 }
      );

      if (newestMessageRef.current) {
        observer.observe(newestMessageRef.current);
      }

      return () => {
        if (newestMessageRef.current) {
          observer.unobserve(newestMessageRef.current);
        }
      };
    }, [chat]);

    return (
      <>
        <div ref={chatContainerRef} className={styles.chatTab}>
          {[...chat].reverse().map((msg, index) => (
            <div key={index} ref={index === 0 ? newestMessageRef : null}>
              <Message senderName={msg.senderName} text={msg.text} />
            </div>
          ))}
        </div>
        <div className={styles.sendMessage}>
          <input
            ref={textInputRef}
            type="text"
            placeholder="إكتب رسالة"
            onKeyDown={(e) => {
              if (e.key === "Enter" && textInputRef.current?.value) {
                sendMessage({
                  senderId: uid,
                  senderName: user_display_name,
                  text: textInputRef.current.value,
                });
                textInputRef.current.value = "";
              }
            }}
          />
          <Button
            className="rounded-full bg-primary text-white"
            onClick={() => {
              if (!textInputRef.current?.value) return;
              sendMessage({
                senderId: uid,
                senderName: user_display_name,
                text: textInputRef.current.value,
              });
              textInputRef.current.value = "";
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              fill="white"
              className="bi bi-send"
              viewBox="0 0 16 16"
            >
              <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z" />
            </svg>
          </Button>
        </div>
      </>
    );
  }
);

export default Chat;
